import React, { PropTypes } from 'react';
import Translator from 'bazinga-translator';
import classNames from 'classnames';

const DraftDeleteMask = (props)=> {

    const deleteClass = classNames({
       'box-drafts__delete' : true,
        'active' : props.active
    });

    return (
    <div className={deleteClass}>
        <div onClick={props.onClose}>
            <div className="burger"><span></span></div>
        </div>
        <div><button className="btn -on-dark -full" onClick={()=>props.onRemoveAll(props.id)}>{Translator.trans('drafts.options.remove_all', [], 'app')}</button></div>
        <div><button className="btn -on-dark -full" onClick={()=>props.onRemoveCategory(props.id)}>{Translator.trans('drafts.options.remove_category', [], 'app')}</button></div>
    </div>
    )
};

DraftDeleteMask.propTypes = {
    active: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    onRemoveAll: PropTypes.func.isRequired,
    onRemoveCategory: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

export default DraftDeleteMask;


// WEBPACK FOOTER //
// ./src/_app/drafts/components/Draft/DraftDeleteMask.jsx